<template>
  <div>
    <header-vue :anchor="itensMenu" />
    <about-vue />
    <ability-vue />
    <projects-vue />
    <experience-vue />
    <education-vue />
    <contact-vue />
    <footer-vue />
  </div>
</template>

<script>
/* Components */
import HeaderVue from "@/components/Header/Header.vue";

/* Views */
import AboutVue from "@/View/About.vue";
import AbilityVue from "@/View/Ability.vue";
import ProjectsVue from "@/View/Projects.vue";
import ExperienceVue from "@/View/Experience.vue";
import EducationVue from "@/View/EducationView.vue";
import ContactVue from "./View/Contact.vue";
import FooterVue from "./components/Footer/Footer.vue";

export default {
  name: "App",
  components: {
    HeaderVue,
    AboutVue,
    AbilityVue,
    ProjectsVue,
    ExperienceVue,
    EducationVue,
    ContactVue,
    FooterVue,
  },
  setup() {
    const itensMenu = [
      { id: "sobre", title: "Sobre" },
      { id: "habilidades", title: "Habilidades" },
      { id: "projetos", title: "Projetos" },
      { id: "experiencia", title: "Experiência" },
      { id: "educacao", title: "Educação" },
      { id: "contato", title: "Contato" },
    ];
    return { itensMenu };
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --bg-color: #393131;
  --bg-header: #322b2b;
  --bg-buttons: #464646;
  --bg-cards: #5e585c;
  --color-text-buttons: #fff;
  --color-text: #ffffff;
  --fs-title: 1.875rem;
  --fs-text-1: 1.25rem; /* 20px */
  --fs-text-2: 1rem;
  --fs-text-buttons: 1.25rem;
}

html {
  scroll-behavior: smooth;
}

.container {
  width: 80%;
  margin: 0 auto;
}

section {
  width: 100%;
  padding: 5rem 0;
}

section:nth-child(odd) {
  background: #464646;
}

img {
  display: block;
  max-width: 100%;
  width: 100%;
  height: 100%;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

@font-face {
  font-family: "Montserrat";
  src: url("@/assets/fonts/montserrat/Montserrat-Bold.ttf");
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}

@font-face {
  font-family: "Raleway";
  src: url("@/assets/fonts/raleway/static/Raleway-Regular.ttf");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

body {
  background: var(--bg-color);
}
</style>
